module.exports = __webpack_public_path__ + "static/media/IDP_inactive.8ceb9bc9.svg";